import { privateCallEntity } from '@/src/entities/private-call'

export function checkStatusIsCallign(): boolean {
  const store = privateCallEntity.model.usePrivateCallStore()
  return store.status === 'calling'
}
